var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5b0fcbaa48d9fa7270c2b5a39083fa6cbc7d803f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"5b0fcbaa48d9fa7270c2b5a39083fa6cbc7d803f"};
      